import React, { useEffect } from 'react';
import AboutContent from '../Components/AboutContent/AboutContent';

const About = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  });

  return (
    <AboutContent />
  );
};

export default About;
